import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class HrApiClient {
  protected readonly http = inject(HttpClient);
  protected readonly baseUrl = `${environment.restApiUrl}hr`;

  protected params(values: object): HttpParams {
    let params = new HttpParams();
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, String(value));
      }
    }
    return params;
  }
}

export type Constructor<T = object> = new (...args: any[]) => T;
